import {
  BLOCKER_ID,
  POPUP_CONTACT_ID,
  showSiteBlocker,
  hideSiteBlocker,
  getTransitionTime,
  showElementTransition,
  hideElementTransition,
} from '../components/popup';

document.addEventListener('DOMContentLoaded', function() {
  // Check if LiveZilla is defined / for testing purposes only
  /* let checkLiveZilla = setInterval(function() {
    if (typeof LiveZilla !== 'undefined') {
      console.log('Livezilla is defined');
      console.log(LiveZilla);
      clearInterval(checkLiveZilla);
    }
  }, 1000); */

  /* let checkAvalability = setInterval(function() {
    if (typeof OverlayChatWidgetV2 !== 'undefined') {
      //console.log('OverlayChatWidgetV2 is defined');
      //console.log(OverlayChatWidgetV2);
      setTimeout(function() {
        if (typeof OverlayChatWidgetV2.IsChatAvailable !== 'function') {
          //console.log('Chat available: ', OverlayChatWidgetV2.IsChatAvailable());
          if (OverlayChatWidgetV2.IsChatAvailable()) {
            //console.log('Chat available');
            clearInterval(checkAvalability);
          }
        }
      }, 500);
    }
  }, 1000); */

const TRANSITION_SPEED = 'slow';
const SITE_BLOCKER = $(BLOCKER_ID);
const POPUP_CONTACT_BUTTON = $('.site-popup__contact-button');
const POPUP_CONTACT = $(POPUP_CONTACT_ID);
const POPUP_CONTACT_CLOSE = $(
  '#site-popup__contact .site-popup__contact-content .btn.btn--close'
);
const INITIAL_BUTTON = POPUP_CONTACT_BUTTON[0]; // Ursprünglicher Button für Fokuswiederherstellung

let lastFocusedElement = null; // Variable, um den zuletzt fokussierten Button zu speichern

// Toggle click on fixed contact button
POPUP_CONTACT_BUTTON.click(function (e) {
  e.preventDefault();
  if (!POPUP_CONTACT.hasClass('active')) {
    lastFocusedElement = document.activeElement; // Speichern, welcher Button zuletzt fokussiert war
    showSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED, POPUP_CONTACT_ID);
    showElementTransition(POPUP_CONTACT, TRANSITION_SPEED);

    // Setzen des Fokus auf das erste Eingabefeld im Formular
    setTimeout(() => {
      trapFocus(POPUP_CONTACT); // Fokusfalle aktivieren
      const firstInputField = POPUP_CONTACT.find('form input').first();
      if (firstInputField.length) {
        firstInputField.focus(); // Fokus auf das erste Eingabefeld setzen
      }
    }, 100); // Timeout für sicherstellendes Rendern
  } else {
    closePopupContact();
  }
});

// Click on close x
POPUP_CONTACT_CLOSE.click(function (e) {
  e.preventDefault();
  closePopupContact();
});

// Close popup function
function closePopupContact() {
  hideSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED);
  hideElementTransition(POPUP_CONTACT, TRANSITION_SPEED);

  // Fokus zurück auf den ursprünglichen Button setzen
  if (lastFocusedElement) {
    setTimeout(() => {
      lastFocusedElement.focus();
    }, 100); // Timeout zur Sicherung, dass der Button sichtbar ist
  }

  releaseFocusTrap(); // Fokusbeschränkung entfernen
}

// Expose closePopup to be callable programmatically
window.closePopupContact = closePopupContact;

// Accessibility: Fokus zurücksetzen, wenn ESCAPE gedrückt wird
$(document).on('keydown', function (e) {
  if (e.key === 'Escape' && POPUP_CONTACT.hasClass('active')) {
    closePopupContact();
  }
});

// Focus Trap Implementation
function trapFocus(container) {
  const focusableElements = container.find(
    'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
  ); // Alle interaktiven Elemente im Pop-up
  const firstFocusableElement = focusableElements.first()[0];
  const lastFocusableElement = focusableElements.last()[0];

  // Listener für Tabulator-Navigation hinzufügen
  container.on('keydown.focusTrap', function (e) {
    if (e.key === 'Tab') {
      // Wenn Shift+Tab gedrückt wird (zum vorherigen Fokuselement)
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus(); // Fokus auf das letzte Element setzen
        }
      } else {
        // Wenn nur Tab gedrückt wird (zum nächsten Fokuselement)
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus(); // Fokus auf das erste Element setzen
        }
      }
    }
  });
}

// Remove Focus Trap
function releaseFocusTrap() {
  POPUP_CONTACT.off('keydown.focusTrap'); // Entfernt den Keydown-Listener
}





  $('.site-popup__contact-content').on('click', '.kid-form button', function(e) {
    e.preventDefault();

    const typeNum = 1718997571;
    const form = $(this).parents('.kid-form');
    const formElement = document.getElementById('kidFormCallback');

    const loader = form.parents('.form-container').find('.form-container__overlay');

    loader.fadeIn(250).attr('style', 'display:table;');

    let formData = formElement ? new FormData(formElement) : null,
      url = formElement && 'action' in formElement ? formElement.action + '?type=' + typeNum : '';

    formData.append('ceUid', form.find('#popup-contact-ce-uid').val());
    formData.append('telephoneNumber', form.find('#popup-contact-phone').val());
    formData.append('timePeriod', form.find('#popup-contact-time').val());
    formData.append('dataPrivacy', form.find('#popup-contact-data-privacy').is(':checked'));
    formData.append('captcha', form.find('#popup-contact-captcha').val());

    if (url) {
      $.ajax({
        async: 'true',
        type: 'POST',
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
        url: url,
        crossDomain: true,
        dataType: 'json',
      })
        .done(function(response) {
          if (!response.success && response.errors) {
            ['telephoneNumber', 'timePeriod', 'dataPrivacy', 'captcha'].forEach((element) => {
              console.log('reset ' + element);
              let inputField;
              switch (element) {
                case 'telephoneNumber':
                  inputField = form.find('#popup-contact-phone');
                  break;
                case 'timePeriod':
                  inputField = form.find('#popup-contact-time');
                  break;
                case 'dataPrivacy':
                  inputField = form.find('#popup-contact-data-privacy');
                  break;
                case 'captcha':
                  inputField = form.find('#popup-contact-captcha');
                  break;
              }
              let fieldWrapper = inputField.parents('.field-wrapper');
              let errorElement = fieldWrapper.find('.kid-form__error');
              fieldWrapper.removeClass('field-wrapper--has-error');
              if (errorElement.length > 0) {
                errorElement.text();
                errorElement.addClass('kid-form__error--hidden');
              }
            });

            let errors = response.errors;

            for (const key in errors) {
              let inputField;
              switch (key) {
                case 'telephoneNumber':
                  inputField = form.find('#popup-contact-phone');
                  break;
                case 'timePeriod':
                  inputField = form.find('#popup-contact-time');
                  break;
                case 'dataPrivacy':
                  inputField = form.find('#popup-contact-data-privacy');
                  break;
                case 'captcha':
                  inputField = form.find('#popup-contact-captcha');
                  break;
              }
              if (typeof inputField !== 'undefined') {
                let fieldWrapper = inputField.parents('.field-wrapper');
                fieldWrapper.addClass('field-wrapper--has-error');
                let errorElement = fieldWrapper.find('.kid-form__error');
                if (errorElement.length === 0) {
                  $(`<span class="kid-form__error">${errors[key]}</span>`).appendTo(fieldWrapper);
                } else {
                  errorElement.text(errors[key]);
                  errorElement.removeClass('kid-form__error--hidden');
                }
              }
            }
            form.find('#popup-contact-captcha').val('');
            form
              .find('#popup-contact-captcha')
              .parents('.captcha-field')
              .find('.captcha__reload')
              .click();
          } else {
            form.parents('.form-container').html(response.message);
          }
          loader.fadeOut(250);
          //form.parents('.form-container').html(response);
        })
        .fail(function(jqXHR, textStatus, error) {
          console.warn('Failure');
          console.log(jqXHR.responseText);
          console.log(textStatus);
          console.log(error);
        });
    } else {
      console.error('insufficient request data', {
        url: url,
      });
    }
  });
});
